/** управление брендами
 */
import _ from "lodash";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import IntlMessages from "util/intlMessages";
import { Table } from "reactstrap";
import { useRouteMatch, Link } from "react-router-dom";
import qs from "query-string";
import { adminAPI } from "redux/api";
import { FormButton } from "./Form";
import { useIntl } from "react-intl";
import { Finder, Pager, FilterButton, TableLoading } from "components/standart";
import { history } from "redux/store";
import { limit } from "variables";

import { apiUrls } from "../init";

const { api } = adminAPI.actions;

const ContentTable = (props) => {
  const { url } = useRouteMatch();
  const intl = useIntl();
  const [contentData, setContentData] = useState({ total: 0 });
  const [query, setQuery] = useState({});

  const dateTimeFormat = intl.formatMessage({ id: "dateTimeFormat" });

  const { contentForm, contentInfo } = props;

  useEffect(() => {
    setQuery({ limit, order: "-createdAt", ...qs.parse(history.location.search) });
  }, [history.location]);

  useEffect(() => {
    const onSuccess = (body) => {
      setContentData(body);
    };
    const onRequest = () => {
      setContentData({ total: -1 });
    };

    query.limit && props.getContent({ query: { ...query } }, { onSuccess, onRequest });
  }, [query]);

  return (
    <>
      <Table responsive>
        <thead className="text-nowrap">
          <tr>
            <th>
              <Finder className="mr-1 d-inline" isActive={query.name}>
                <Finder.input name="name" {...{ query, setQuery }} />
              </Finder>
              <IntlMessages id="Sounds.Voices.name" />
            </th>

            <th>
              <IntlMessages id="Sounds.Voices.service" />
            </th>

            <th>
              <IntlMessages id="Sounds.Voices.voice" />
            </th>

            <th>
              <IntlMessages id="Sounds.Voices.model" />
            </th>

            <th>
              <IntlMessages id="Sounds.Voices.isDefault" />
            </th>
            <th>
              <IntlMessages id="Sounds.Voices.isService" />
            </th>
            {/* 
            <th>
              <IntlMessages id="tables.created" />
              <Sorter query={query} url={url} order="createdAt" /> 
            </th>
            */}
            <th>
              <Finder.search {...{ query, url }}>
                <div>
                  <FilterButton
                    className="mr-1"
                    on="lock"
                    off="lock-open"
                    id="tables.blocked_filter"
                    name="blocked"
                    {...{ query, setQuery }}
                  />
                </div>
              </Finder.search>
            </th>
          </tr>
        </thead>
        {contentData.total < 0 && <TableLoading />}

        <tbody>
          {_.map(contentData.data, (content, key) => (
            <tr key={key} className={`${!content.enabled ? "text-strike" : ""}`}>
              <td>
                <Link to={contentInfo(content)}>{content.name}</Link>
              </td>
              <td>{content.service}</td>
              <td>{content.voice}</td>
              <td>{content.model}</td>
              <td>
                <IntlMessages id={content.isDefault ? "yes" : "no"} />
              </td>
              <td>
                <IntlMessages id={content.isService ? "yes" : "no"} />
              </td>
              {/* <td>{moment(new Date(content.createdAt)).format(dateTimeFormat)}</td> */}
              <td>
                <FormButton {...{ content, contentForm }} />
              </td>
            </tr>
          ))}
        </tbody>

        <tfoot>
          <tr>
            <td colSpan="99">
              <Pager query={query} url={url} total={contentData.total} />
            </td>
          </tr>
        </tfoot>
      </Table>
    </>
  );
};

export default connect(null, {
  getContent: api.get(apiUrls.voices),
})(ContentTable);
